import debugT from 'debug';
import container from 'modules/section-content';
import domify from 'domify';
import 'bootstrap';
import 'slick-carousel';
import $ from 'jquery';
import page from 'modules/ab-page-js';
import splash from './view/index.pug';
import metadata from './metadata.json';
import Animation from 'modules/animation-timeline';
import AnimationScroll from 'modules/animation-scroll';
import ContactForm from 'auth0-contact-form';

const animationScroll = new AnimationScroll();
const metricsLib = window.metricsLib;

export default function register() {
  page('/gdpr', render, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  next();
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:gdpr-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:gdpr-contact-form', metricsData);
    },
    source: 'gdpr'
  };

  /* eslint-env browser */

  const salesContactForm = new ContactForm(salesContactFormOptions);
  document.querySelectorAll('.open-contact-form-modal').forEach(element => {
    element.addEventListener(
      'click',
      () => {
        salesContactForm.show({ includePhoneField: true });
      },
      false
    );
  });
}

function snippets(ctx, next) {
  contactFormModals();

  next();
}



// WEBPACK FOOTER //
// ./src/pages/gdpr/client.js